<div class="c-widget">
  <div class="c-widget__header">
    <div class="c-widget__content-left">
      <div class="c-widget__title" i18n="@@common.signed_documents">Signed Documents</div>
      <button p500-ui-button-icon size="small" color="primary" type="button" (click)="getData()">
        <p500-ui-icon name="controls-refresh"></p500-ui-icon>
      </button>
    </div>
  </div>
  <div class="c-widget__body">
    <ng-container *ngIf="isLoading; then loadingTmpl; else dataTmpl"></ng-container>
  </div>
</div>

<ng-template #loadingTmpl>
  <p500-ui-cube-preloader></p500-ui-cube-preloader>
</ng-template>

<ng-template #dataTmpl>
  <ng-container *ngIf="data.crm_terms?.length; else emptyTmpl">
    <div class="profile-terms">
      <div class="profile-terms__item" *ngFor="let doc of data.crm_terms" [class.-new]="!doc.agreed" (click)="openModal([doc])">
        <span class="profile-terms__id">{{ doc.document.id }}</span>
        <span class="profile-terms__name">{{ doc.document.name }}</span>
        <div class="profile-terms__icon">
          <span class="label" [hidden]="doc.agreed" i18n="@@common.new">New</span>
          <i class="profile-terms__icon p500-ui-icon-other-wiki"></i>
        </div>
      </div>
    </div>
  </ng-container>
  <!--  -->
  <ng-template #emptyTmpl>
    <gtd-empty [icon]="'box'" [noBorder]="true" i18n-desc="@@common.data_wasnt_found" desc="Data wasn't found."> </gtd-empty>
  </ng-template>
</ng-template>
